
const formatPrice = (price, currency) => {
  const parsed_price = parseFloat(price).toFixed(2).replace('.', ',')
  switch (currency) {
    case "PLN":
      return `${parsed_price} zł`
    default:
      return `${parsed_price} ${currency}`
  }
}


export default formatPrice;
